import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Stack,
  Avatar,
  CircularProgress,
} from "@mui/material";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import { API_BASE } from "../../config/api";

const EditarPerfil = () => {
  const { user,fetchMe, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  // ===============================
  // Estados
  // ===============================
  const [form, setForm] = useState({
    name: "",
    lastName: "",
    email: "",
    password: "",
  });

  const [avatar, setAvatar] = useState(null);
  const [preview, setPreview] = useState(null);
  const [saving, setSaving] = useState(false); // ⬅️ loading submit

  // ===============================
  // Inicializar formulario
  // ===============================
  useEffect(() => {
    if (user) {
      setForm({
        name: user.name || "",
        lastName: user.lastName || "",
        email: user.email || "",
        password: "",
      });
      setPreview(user.avatar || null);
    }
  }, [user]);

  // ===============================
  // LOADING GLOBAL (Auth)
  // ===============================
  if (authLoading) {
    return (
      <Box
        sx={{
          minHeight: "60vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // ===============================
  // Seguridad extra
  // ===============================
  if (!user) {
    return (
      <Box sx={{ mt: 10, textAlign: "center" }}>
        <Typography>No se pudo cargar el usuario</Typography>
      </Box>
    );
  }

  // ===============================
  // Handlers
  // ===============================
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setAvatar(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (saving) return;

    setSaving(true);

    const token = localStorage.getItem("token");
    const formData = new FormData();

    Object.entries(form).forEach(([key, value]) => {
      if (value) formData.append(key, value);
    });

    if (avatar) {
      formData.append("avatar", avatar);
    }

    try {
      const res = await fetch(`${API_BASE}/users/me`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!res.ok) throw new Error("Error al actualizar");
fetchMe(token)
    } catch (error) {
      console.error(error);
      alert("Error al actualizar perfil");
    } finally {
      setSaving(false);
    }
  };

  // ===============================
  // Render
  // ===============================
  return (
    <>
    <Navbar/>

 
    <Box sx={{ mt: 10, maxWidth: 500, mx: "auto" }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h5" sx={{ mb: 3 }}>
          Editar Perfil
        </Typography>

        {/* Avatar */}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          <Avatar src={preview} sx={{ width: 80, height: 80 }} />
        </Box>

        <Button
          component="label"
          fullWidth
          sx={{ mb: 3 }}
          disabled={saving}
        >
          Cambiar avatar
          <input
            hidden
            type="file"
            accept="image/*"
            onChange={handleAvatarChange}
          />
        </Button>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <Stack spacing={2}>
            <TextField
              label="Nombre"
              name="name"
              value={form.name}
              onChange={handleChange}
              disabled={saving}
            />

            <TextField
              label="Apellido"
              name="lastName"
              value={form.lastName}
              onChange={handleChange}
              disabled={saving}
            />

            <TextField
              label="Email"
              name="email"
              value={form.email}
              onChange={handleChange}
              disabled={saving}
            />

          {/*   <TextField
              label="Nueva contraseña"
              type="password"
              name="password"
              helperText="Opcional"
              onChange={handleChange}
              disabled={saving}
            /> */}

            <Button
              type="submit"
              variant="contained"
              disabled={saving}
              startIcon={
                saving ? <CircularProgress size={20} color="inherit" /> : null
              }
            >
              {saving ? "Guardando..." : "Guardar cambios"}
            </Button>
          </Stack>
        </form>
      </Paper>
    </Box>
    <Footer/>
    </>

  );
};

export default EditarPerfil;
